import { ReactNode } from "react";
import { ModalComponent } from "..";

export const NotificationModal = ({
  isModalOpen,
  onModalClose = () => {},
  title,
  subText,
  children,
}: {
  isModalOpen: boolean;
  onModalClose?: () => void;
  title?: ReactNode;
  subText?: ReactNode;
  children?: ReactNode;
}) => {
  return (
    <ModalComponent
      isModalOpen={isModalOpen}
      onModalClose={() => {
        onModalClose();
      }}
      title={title}
      subTitle={subText}
      childrenClassName=""
      modalClassName=""
      hasButtons={false}
      proceedButtonText=""
      onProceedClick={() => {}}
      hasCancelButton={false}
      onCancelClick={() => {}}
      isLoading={false}
      isProceedDisabled={false}
    >
      {children}
    </ModalComponent>
  );
};
